import { FormInputRow } from 'components/input';
import React, { ChangeEvent } from 'react';
import { useAllImagingSettings } from 'redux/hooks/common';
import { getAllScoreGroups } from 'utils/Global';
import { ImageWellScoresAutoScore } from '.';

interface Props {
  handleSelectionChange: (e: ChangeEvent<HTMLInputElement | HTMLSelectElement>) => void;
  scoringOptionSelectedState: ImageWellScoresAutoScore;
}

const ScoringOptionSelector = (props: Props) => {
  const { scoringOptionSelectedState, handleSelectionChange } = props;

  const allImagingSettingProfiles = useAllImagingSettings().captureProfileRows.map(
    (x) => ({ title: x.name, value: x.id }),
  );

  /**
   * Filter score groups that are auto score and are not unit score and are not inherit
   * This filter  is temporary, we need to have a simple auto socre flag for these type of groups.
   *
   */
  const collator = new Intl.Collator(undefined, { numeric: true, sensitivity: 'base' });
  const scoreGroups = getAllScoreGroups()
    .filter(
      (x) =>
        x.isAutoScore && x.unit == null && x.isInherit == false && x.scoreGroupType == 0,
    )
    .map((x) => ({ title: x.name, value: x.scoreGroupsId }))
    .sort((a, b) => collator.compare(a.title, b.title));

  return (
    <div id='scoringoptionselector-wrapper' >
      <FormInputRow
        id={`scoringoptionselector-scoregroup-input`}
        labeltext="Score"
        inputType="select"
        options={scoreGroups}
        value={scoringOptionSelectedState.scoreGroup}
        name="scoreGroup"
        onChange={handleSelectionChange}
      />
      <FormInputRow
        id={`scoringoptionselector-imagesettings-input`}
        labeltext="Image Settings"
        inputType="select"
        options={allImagingSettingProfiles}
        value={scoringOptionSelectedState.imageSettings}
        name="imageSettings"
        onChange={handleSelectionChange}
      />
    </div>
  );
};

export default ScoringOptionSelector;
